import EasyCropper from 'react-easy-crop'
import { useImageCropContext } from './ImageCropProvider'

const Cropper = () => {
  const { image, zoom, setZoom, rotation, crop, setCrop, onCropComplete, shape, aspectRatio } = useImageCropContext()
  return (
    <EasyCropper
      image={image || undefined}
      crop={crop}
      zoom={zoom}
      rotation={rotation}
      cropShape={shape}
      aspect={aspectRatio}
      onCropChange={setCrop}
      onCropComplete={onCropComplete}
      onZoomChange={setZoom}
      restrictPosition={false}
      //   setRotation={setRotation}
      showGrid={false}
      // cropSize={shape === `round` ? { width: 185, height: 185 } : { width: 150, height: 150 }}
      style={{
        containerStyle: {
          height: `100%`,
          width: `100%`,
        },
      }}
    />
  )
}

export default Cropper
